import { jsx as _jsx } from "react/jsx-runtime";
import Item from "components/Emails/Item";
import UPDATE_EMAILS_FOOTERS from "mutations/emails/updateEmailsFooter";
import GET_EMAILS_FOOTER from "queries/emails/getEmailsFooter";
const FootersItem = () => (_jsx(Item, { getQuery: GET_EMAILS_FOOTER, getQueryDataName: "getEmailsFooter", itemName: "footer", updateMutation: UPDATE_EMAILS_FOOTERS }));
export default FootersItem;
